import { Button } from "design-system/atoms/Button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "design-system/atoms/Dialog"
import { Switch } from "design-system/atoms/Switch"
import { useState } from "react"
import { useTranslation } from "react-i18next"

type Props = {
  value: boolean
  onChange: (value: boolean) => void
}

export function ShouldUseIntegration({ value, onChange }: Props) {
  const { t } = useTranslation()
  const [isDialogOpen, setIsDialogOpen] = useState(false)

  function onSwitchChange(value: boolean) {
    if (value) {
      setIsDialogOpen(true)
    } else {
      onChange(value)
    }
  }

  function handleConfirm() {
    onChange(true)
    setIsDialogOpen(false)
  }

  return (
    <>
      <div className="flex items-center gap-2">
        <Switch
          value={value.toString()}
          checked={value}
          onCheckedChange={onSwitchChange}
          id="useChannel"
        />
        <label className="text-base" htmlFor="useChannel">
          {t("customers.useChannel.label")}
        </label>
        <Dialog
          open={isDialogOpen}
          onOpenChange={(val) => {
            if (val === false) {
              setIsDialogOpen(false)
            }
          }}
          modal={true}
        >
          <DialogContent>
            <DialogHeader>
              <DialogTitle>{t("customers.useChannel.warning.title")}</DialogTitle>
              <DialogDescription>{t("customers.useChannel.warning.description")}</DialogDescription>
              <DialogDescription>
                {t("customers.useChannel.warning.description2")}
              </DialogDescription>
            </DialogHeader>
            <div className="mt-4 flex justify-end space-x-3">
              <Button variant="outline" onClick={() => setIsDialogOpen(false)}>
                {t("shared.cancel")}
              </Button>
              <Button onClick={handleConfirm}>{t("shared.confirm")}</Button>
            </div>
          </DialogContent>
        </Dialog>
      </div>
    </>
  )
}
